import React, {Fragment} from 'react';
import {DropdownButton, Glyphicon, Image, MenuItem, OverlayTrigger, Panel, Popover, Table} from 'react-bootstrap';
import {withRouter} from 'react-router-dom';
import * as moment from 'moment';
import './TeamsPanel.css';
import AssessmentLineChart from './AssessmentLineChart';
import CoachImage from '../../img/baseline-person-24px.svg';
import GroupImage from '../../img/baseline-group-24px.svg';
import GreenLeafApi from '../utils/GreenLeafApi';
import GroupDetailsTable from './GroupDetailsTable';
import ProgressBarItem from './ProgressBar';
import SelectSubsectionModal from './SelectSubsectionModal';
import PropTypes from 'prop-types';
import TablePager from '../TablePager';
import ErrorComponent from '../ErrorComponent';

class AssessmentsPanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      scores: [],
      groupScoreDetails: [],
      error: null,
      showModal: false,
      assessDetail: null,
      activePage: 1,
      maxPageItems: {value: 5, label: '5'},
    };
    this.fetchGroupAssessments = this.fetchGroupAssessments.bind(this);
  }

  async componentDidMount() {
    try {
      await this.fetchGroupAssessments();
      let scores = [...this.props.coachScores,...this.props.groupScores];
      scores.sort((a, b) => Date.parse(b['assessment_date']) - Date.parse(a['assessment_date']));
      this.setState({scores});
    } catch (e) {
      this.setState({ error: e.errors });
    }
  }

  async fetchGroupAssessments() {
    let groupScoreDetails = {};
    const detailPromises = [];
    this.props.groupScores.forEach(a => {
      detailPromises.push(GreenLeafApi.GroupTeamAssessment.get({group_assessment_id: a.group_team_assessment_id}));
    });

    const detailResponses = await Promise.all(detailPromises);
    for (const response of detailResponses) {
      if (response.data.length > 0) {
        groupScoreDetails[response.data[0].group_assessment_id] = response.data;
      }
    }
    this.setState({groupScoreDetails});
  }

  getReportLink = (score) => {
    let link = '';

    if (score['team_assessment_id']) {
      link = `/companies/${this.props.match.params.companyId}/programs/${this.props.match.params.programId}/teams/${this.props.match.params.teamId}/reports/${score.team_assessment_id}`;
    } else {
      link = `/companies/${this.props.match.params.companyId}/programs/${this.props.match.params.programId}/teams/${this.props.match.params.teamId}/selfreports/${score.group_team_assessment_id}`;
    }

    return link;
  };

  getNextButtonDisabled = () => { return this.state.activePage === this.getMaxPage(); };

  getMaxPage = () => {
    let maxPage = this.state.scores.length / this.state.maxPageItems.value;
    maxPage = Math.ceil(maxPage);
    return maxPage;
  };

  clickModal = (s) => {
    s.complete ? this.setState({showModal: true, assessDetail: s }) : this.setState({showModal: false});
  };

  handleSubmitSubs = (assessment, groupSubs) => {
    if (assessment) {
        this.setState({showModal: false});
        this.props.history.push(`/companies/${this.props.match.params.companyId}/programs/${this.props.match.params.programId}/teams/${this.props.match.params.teamId}/assessment`);
    } else {
        this.setState({showModal: false});
        this.props.history.push({pathname: `/companies/${this.props.match.params.companyId}/programs/${this.props.match.params.programId}/teams/${this.props.match.params.teamId}/selfassessment/create`,
            state: { subsection_ids: groupSubs }});
    }
  };

  handleMaxItemsChange = maxPageItems => {
    this.setState({maxPageItems});
    const maxPage = Math.ceil(this.state.scores.length / maxPageItems.value);
    if(this.state.activePage > maxPage){
      this.setState({activePage: maxPage});
    }
  };

  changePage = (pageNum) => {
    this.setState({activePage: pageNum});
  };

  getTable = (scores) => {
    const popovers = {};
    for (const [assessmentId, details] of Object.entries(this.state.groupScoreDetails)) {
      popovers[assessmentId] = (
        <Popover id={assessmentId}>
          <GroupDetailsTable details={details}/>
        </Popover>
      );
    }

    return(
      <Table responsive>
        <thead className="text-primary pl1">
        <tr>
          <th>Date</th>
          <th>Score</th>
          <th>Type</th>
          <th>Status</th>
        </tr>
        </thead>
        <tbody className="pl1">
        { scores.map((s, i) => {
          const isGroup = !s['team_assessment_id'];

          return(
            <tr className="item" key={i}>
              <td className="h4">
                {moment(new Date(s.assessment_date)).format('MM/DD/YYYY')}
              </td>
              <td>
                <ProgressBarItem
                  placement={'left'}
                  score={s.calculated_score || 0}
                  width={'200px'}
                />
              </td>
              <td className="h4">
                { isGroup
                  ?
                  <Image src={GroupImage} responsive/>
                  :
                  <Image src={CoachImage} responsive/>
                }
              </td>
              { isGroup
                ?
                <td>
                  <div className='flex-row'>
                    <h4 style={{width: 'fit-content'}}>
                      { s.complete
                        ?
                        'Complete'
                        :
                        <Fragment>
                          In Progress
                          <OverlayTrigger trigger={'click'} rootClose placement='right' overlay={popovers[s.group_team_assessment_id]}>
                            <Glyphicon className='ml1' glyph='info-sign'/>
                          </OverlayTrigger>
                        </Fragment>
                      }
                    </h4>


                  </div>
                </td>
                :
                <td className="h4">
                  { s.complete
                    ?
                    'Complete'
                    :
                    'In Progress'
                  }
                </td>
              }
              <td className={'text-right'}>
                <DropdownButton
                  data-cy={'assess-dropdown-' + i}
                  id='dropdown'
                  title={<i className="fas fa-chevron-down"/>}
                  noCaret={true}
                  pullRight
                >
                  <MenuItem onSelect={() => this.props.history.push(this.getReportLink(s))}>
                    View Report
                  </MenuItem>
                  {s.complete &&
                  <MenuItem data-cy={'reassess-button-' + i } onClick={() => this.clickModal(s)}>
                    Re-Assess
                  </MenuItem>
                  }
                </DropdownButton>
              </td>
            </tr>
          );
        })
        }
        </tbody>
      </Table>
    );
  };

  render() {
    return (
      <div className="panel-container">
        <Panel>
          <Panel.Heading data-cy="assessments-panel">
            <Panel.Title componentClass="h3">
              Assessments
            </Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <ErrorComponent error={this.state.error}/>
            { this.props.notAssessed ?
              <p>No assessments found for this team.</p>
              :
              <Fragment>
                  <AssessmentLineChart coachScores={this.props.coachScores} groupScores={this.props.groupScores} startDate={this.props.startDate}/>
                <br/>
                <Panel data-cy="assessments-list">
                  <Panel.Heading>
                    <Panel.Title componentClass="h3">
                      Assessments by Date
                    </Panel.Title>
                  </Panel.Heading>
                  <Panel.Body>
                    <TablePager data={this.state.scores} dataTable={this.getTable}/>
                  </Panel.Body>
                </Panel>
              </Fragment>
            }
              <SelectSubsectionModal
                  assessDetail={this.state.assessDetail}
                  show={this.state.showModal}
                  handleClose={() => this.setState({ showModal: false })}
                  handleSubmitSubs={this.handleSubmitSubs}/>
          </Panel.Body>
        </Panel>
      </div>
    );
  }
}

AssessmentsPanel.propTypes = {
  notAssessed: PropTypes.bool,
  coachScores: PropTypes.array,
  groupScores: PropTypes.array,
};

export default withRouter(AssessmentsPanel);


// WEBPACK FOOTER //
// ./src/components/teams/AssessmentsPanel.js